import {useNavigate} from "react-router-dom";
import {mapOverlayPanes} from "base/component/geo";
import {createLayerLegend, useLayerObject} from "base/map";

const markerBaseOptions = {
    marker: "v",
    fillColor: "#014868",
    radius: 9,
    color: "white",
    weight: 2,
    opacity: 1,
    fillOpacity: 1,
    pane: mapOverlayPanes[7],
};

const markerSelectedOptions = {
    weight: 2,
    opacity: 1,
    color: "#ff0",
};

const markerHighlightOptions = {
    weight: 2,
    opacity: 1,
    color: "#fff",
};

const markerSuperHighlightOptions = {
    weight: 4,
    opacity: 1,
    fillOpacity: 1,
    color: "#fff",
    radius: 13,
};

const discriminators = Object.freeze({
    DESACTIVADA: null,
    ABASTECEMENTO_AUTONOMO: "titular",
});

export const LayerLegend = createLayerLegend({
    layerName: "Captacións",
    menuIconShape: markerBaseOptions.marker,
    discriminatorsAttributes: discriminators,
    discriminatorsLegends: [
        {
            field: discriminators.DESACTIVADA,
            text: "- Desactivada -",
            defaultIconOptions: markerBaseOptions,
            entries: [
                {
                    text: "",
                    filterFn: val => true,
                    markerOptions: {
                        ...markerBaseOptions,
                    },
                },
            ],
        },
        {
            field: discriminators.ABASTECEMENTO_AUTONOMO,
            text: "Abastecemento",
            defaultIconOptions: markerBaseOptions,
            entries: [
                {
                    text: "Municipal",
                    filterFn: val => val !== 2 && val !== 6,
                    markerOptions: {...markerBaseOptions, radius: 14, dashArray: null},
                },
                {
                    text: "Autónomo",
                    filterFn: val => val === 2 || val === 6,
                    markerOptions: {
                        ...markerBaseOptions,
                        radius: 10,
                        dashArray: "1,3",
                        color: markerBaseOptions.fillColor,
                        fillColor: "#69a8c5",
                    },
                },
            ],
        },
    ],
});

export function useLayer(detail = false) {
    const navigate = useNavigate();

    return useLayerObject({
        legend: LayerLegend,
        detail: detail,
        selectedMarkerOptions: markerSelectedOptions,
        highlightMarkerOptions: markerHighlightOptions,
        superHighlightMarkerOptions: markerSuperHighlightOptions,
        getTooltip: ({feature}) => {
            let data = feature.properties;
            let tooltip = `<b>Captación: ${
                feature.id ? feature.id : "---"
            }</b><ul class="attributes">`;
            if (data["sistema"]) {
                tooltip += `<li><i>Sistema</i>: ${data["sistema_label"]}</li>`;
            }
            tooltip += `<li><i>Código</i>: ${
                data["codigo"] ? data["codigo"] : "---"
            }</li>`;
            tooltip += `<li><i>Titular</i>: ${
                data["titular_label"] ? data["titular_label"] : "---"
            }</li>`;
            return tooltip + "</ul>";
        },
        defaultOnClick: ({feature}) => navigate(`info/captacions/${feature.id}`),
    });
}
